module.exports = __webpack_public_path__ + "assets/img/ENVIONACIONALENCURSO.218c763f.svg";